import SapFiReport from "./pages/SapFiReport";
import SapMmReport from "./pages/SapMmReport";
import SapMmErrorReport from "./pages/SapMmErrorReport";
import SapFiErrorReport from "./pages/SapFiErrorReport";
import SapLayout from "./SapLayout";
import SapMmPoVenderReport from "./pages/SapMmPoVenderReport";
import SapFiNotSendReceipt from "./pages/SapFiNotSendReceipt";

export const sapPathRoutes = () => [
  {
    name: "SapFiReport",
    path: "sap-fi-report",
    component: SapFiReport
  },
  {
    name: "SapMmReport",
    path: "sap-mm-report",
    component: SapMmReport
  },
  {
    name: "SapFiErrorReport",
    path: "sap-fi-error-report",
    component: SapFiErrorReport
  },
  {
    name: "SapMmErrorReport",
    path: "sap-mm-error-report",
    component: SapMmErrorReport
  },
  {
    name: "SapMmPoVenderReport",
    path: "sap-mm-po-vender-report",
    component: SapMmPoVenderReport
  },
  {
    name: "SapFiNotSendReceipt",
    path: "sap-fi-not-send-receipt",
    component: SapFiNotSendReceipt
  },
];

export const sapRoutes = {
  path: "sap",
  component: SapLayout,
  children: [
    ...sapPathRoutes()
  ]
};
